import { StyleProp, ViewStyle } from "react-native";
import Loading from "src/components/Loading";
import OpacityView from "src/components/OpacityView";
import Touchable from "src/components/Touchable";
import { IconComponent } from "src/icons";
import { FLOATING_SELECT_HORIZONTAL_MARGIN } from "../constants";

const FloatingActionItem = ({
	loading,
	Icon,
	onPress,
	containerStyle,
	color,
	testID,
}: {
	loading?: boolean;
	Icon: IconComponent;
	onPress?: () => void;
	containerStyle?: StyleProp<ViewStyle>;
	color?: string;
	testID?: string;
}) => {
	return (
		<OpacityView
			testID={testID}
			style={[
				{
					paddingHorizontal: FLOATING_SELECT_HORIZONTAL_MARGIN,
				},
				containerStyle,
			]}
			duration={100}
		>
			<Touchable
				onPress={onPress}
				hitSlop={10}
				style={{
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				{loading ? <Loading /> : <Icon size={20} color={color} />}
			</Touchable>
		</OpacityView>
	);
};
export default FloatingActionItem;
